module.exports = __webpack_public_path__ + "img/adly.6679d623.png";